import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useIsAuthenticated } from '@/hooks/redux';
import { ThemeSwitcher } from '@/components/common/ThemeSwitcher';

export function AuthLayout() {
  const isAuthenticated = useIsAuthenticated();

  // Redirect to dashboard if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen flex">
      {/* Left side - Auth forms */}
      <div className="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
        <div className="mx-auto w-full max-w-sm lg:w-96">
          {/* Theme switcher */}
          {/* <div className="flex justify-end mb-8">
            <ThemeSwitcher />
          </div> */}

          {/* Logo and title */}
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold tracking-tight">Admin</h2>
            <h2 className="text-3xl font-bold tracking-tight">Dragon Vs Tiger</h2>
          </div>

          {/* Auth form content */}
          <Outlet />

          {/* Footer */}
          {/* <div className="mt-8 text-center text-xs text-muted-foreground">
            <p>© 2024 CFT Admin Template. Built with React, TypeScript, and Tailwind CSS.</p>
          </div> */}
        </div>
      </div>

      {/* Right side - Decorative */}
      <div className="hidden lg:block relative w-0 flex-1 overflow-hidden">
        <img
          src="assets/bg-dvt.png"
          alt="Dragon vs Tiger"
          className="absolute inset-0 h-full w-full object-cover opacity-90"
        />

        {/* Dark overlay for readability */}
        <div className="absolute inset-0 bg-black/10" />
      </div>
    </div>
  );
}
